// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"488":"c17b32dd7302918bfd2dca3f45b31e6b92daa58a","691":"component---src-pages-index-tsx","722":"component---src-pages-s-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"488":"1fd3d52ce81dd096983d","691":"06b3543ba865b0de55b7","722":"115c61ce9ffea45047c3","883":"72422bb5518bc506637d"}[chunkId] + ".js";
};